import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in the real incident: ports 80/443 accepting TCP but HTTP
// hanging, `docker ps` showing every app Up but no dokploy-traefik, `ss` showing
// nothing on 80/443, Dokploy crash-looping (exit 255), and the recreate with
// --restart always. See docs/incidents/2026-06-10-traefik-outage-postmortem.md.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "Every site I host went dark at the same moment. The strange part: the server itself was perfectly healthy." },
];

export const TRIAGE: ScriptLine[] = [
  { scene: "triage", fromSec: 0.4, holdSec: 5.5, caption: "The panel said the VPS was fine — 17% CPU, 46% memory, disk only 27% full. Not a dead box." },
  { scene: "triage", fromSec: 6.2, holdSec: 5, caption: "So it wasn't the server. The outage had to be one layer up — in Docker, or the proxy." },
  { scene: "triage", fromSec: 11.5, holdSec: 4, caption: "One clue stood out: the box had been up only 38 minutes. It had just rebooted." },
];

export const PROBE: ScriptLine[] = [
  { scene: "probe", fromSec: 0.4, holdSec: 6, caption: "Ports 80 and 443 accepted a TCP connection — but every HTTP request hung. Zero bytes back." },
  { scene: "probe", fromSec: 6.6, holdSec: 5.5, caption: "That signature — connect succeeds, HTTP never answers — means the proxy is wedged, not the network." },
  { scene: "probe", fromSec: 12.4, holdSec: 3.4, caption: "Time to look inside the box." },
];

export const DOCKERPS: ScriptLine[] = [
  { scene: "dockerps", fromSec: 0.4, holdSec: 6, caption: "docker ps: every app container was Up — eakc, n8n, jyotishai, idea-radar, all of them." },
  { scene: "dockerps", fromSec: 6.6, holdSec: 5.5, caption: "But one was missing. No dokploy-traefik. The reverse proxy — the single front door — was gone." },
  { scene: "dockerps", fromSec: 12.4, holdSec: 5, caption: "In Dokploy, every site is reached only through Traefik. No Traefik means no routes, no sites." },
];

export const PROOF: ScriptLine[] = [
  { scene: "proof", fromSec: 0.4, holdSec: 5.5, caption: "The proof, in one line: nothing was listening on 80 or 443. No router present at all." },
  { scene: "proof", fromSec: 6.2, holdSec: 5, caption: "The apps were alive the whole time. They just had no door in front of them." },
];

export const ROOTCAUSE: ScriptLine[] = [
  { scene: "rootcause", fromSec: 0.4, holdSec: 6, caption: "Why only Traefik? The apps are Swarm services — Docker re-creates those automatically on boot." },
  { scene: "rootcause", fromSec: 6.6, holdSec: 6, caption: "Traefik is the one piece Dokploy runs as a plain standalone container — and it wasn't reboot-safe." },
  { scene: "rootcause", fromSec: 13, holdSec: 5.5, caption: "Dokploy itself crash-looped on boot — exit 255, twice — so its 'recreate Traefik' step never ran." },
];

export const FIX: ScriptLine[] = [
  { scene: "fix", fromSec: 0.4, holdSec: 6, caption: "Everything Traefik needed was intact on disk — its config, the TLS certs, the network. Only the container was gone." },
  { scene: "fix", fromSec: 6.6, holdSec: 6.5, caption: "One docker run brought it back — pointed at the config, and crucially, with restart-always." },
  { scene: "fix", fromSec: 13.4, holdSec: 5.5, caption: "Up on 80 and 443, certs served from the intact acme.json. Every site returned in under a minute." },
];

export const PREVENT: ScriptLine[] = [
  { scene: "prevent", fromSec: 0.4, holdSec: 5.5, caption: "A plain reboot did NOT fix it — proof the cure was the restart policy, not turning it off and on again." },
  { scene: "prevent", fromSec: 6.2, holdSec: 5.5, caption: "Now restart-always brings Traefik back after any reboot. Plus swap for headroom, plus an uptime monitor." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "The lesson: a reboot's blast radius is decided before the reboot — by whether your single points of failure heal themselves." },
  { scene: "outro", fromSec: 5.7, holdSec: 3.6, caption: "Your proxy is a single point of failure. Make it restart: always." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
